import './RASuitabilityTestView.scss';

import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cryptoJS from 'crypto-js';
import classNames from 'classnames';
import Headline from 'components/headline';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { RAWizard } from 'components/RAComponents/RAWizard/RAWizard';
import { RAWizardContent } from 'components/RAComponents/RAWizard/RAWizardContent';
import RARejected from 'components/RAComponents/RARejected/RARejected';
import { RASuitabilityTestSuccess } from './RASuitabilityTestSuccess/RASuitabilityTestSuccess';
import RASuitabilityTestFailure from './RASuitabilityTestFailure/RASuitabilityTestFailure';
import RAModal from 'components/RAComponents/commons/RAModal/RAModal';
import RAImageButton from 'components/RAComponents/commons/RAImageButton/RAImageButton';
import { LoginRoboContainer } from 'components/RAComponents/LoginRobo/LoginRoboContainer';
import RASuitabilityTestWrapper from 'components/RAComponents/RASuitabilityTestWrapper/RASuitabilityTestWrapper';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import suitabilityActions from 'actions/RASuitabilityTest';
import jointHoldersActions from 'actions/jointHoldersActions';
import RASuitabilityTestWizardActions from 'actions/RASuitabilityTestWizardActions';
import preLoaderActions from 'actions/preLoaderActions';
import modalCancelActions from 'actions/modalCancelActions';
import { FormattedText, formatText } from 'core/i18n';
import {
    recordedTestSuccess,
    recordedTestFailure,
    getRecordedTestSuccess,
    getRecordedTestFailure,
} from 'utilities/uTagging';
import Storage from 'utilities/storage';
import scroll from 'utilities/scroll';
import UtagHelper from 'utilities/utagHelper';
import {
    SUITABILITY_TEST_IN_PROGRESS,
    SUITABILITY_TEST_VALID,
    SUITABILITY_TEST_UNSIGNED,
    SUITABILITY_TEST_REDO,
} from 'constants/RAConstants/index';
import {
    TEST_PROCESS_STEP_SUCCESS,
    EVENT_ACTION_LOGIN_ROBO,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_RETAKE_TEST,
    TEST_PROCESS_STEP_FAILURE,
    EVENT_DETAIL_RESULT_LOAD,
    EVENT_DETAIL_MODAL_EXIT_OPEN,
    EVENT_DETAIL_FINISH,
    EVENT_ACTION_EXIT_TEST,
    EVENT_DETAIL_MODAL_EXIT_NEXT,
    EVENT_DETAIL_CLOSE_MODAL,
    EVENT_CATEGORY_RA_REJECTED,
    EVENT_ACTION_RA_REJECTED,
    EVENT_DETAIL_BUTTON_NEXT,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_SIGN,
    EVENT_ACTION_PASSWORD_RECOVERY,
    EVENT_DETAIL_EXIT,
} from 'constants/uTagConstants/RAConstants';
import { PATH_ROBO_TI, PATH_GBI_TI, PATH_RA_REJECTED } from 'constants/uTagConstants/paths';
import { ROBO, GBI, ROBO_REJECTED, GBI_REJECTED } from 'constants/userProfile';
import {
    ERROR_AL_EVIAR_RECHAZO_GBI,
    ERROR_AL_EVIAR_RECHAZO_ROBO,
    ERROR_TEST_IDONEIDAD,
} from 'constants/analyticsErrors';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import Close from 'assets/icons/close.svg';

class RASuitabilityTestViewComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            showOtpComponent: false,
            showModal: false,
        };
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { products, userProfile, immStepsState, recordAndSavePage } = this.props;
        const welcomeCard = immStepsState.get('welcomeCard');

        !welcomeCard &&
            recordAndSavePage(
                PATH_ROBO_TI,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                false,
                '',
                '',
                userProfile.investmentType,
                {
                    identificadorOnboarding: userProfile.docNumber
                        ? cryptoJS.SHA256(userProfile.docNumber).toString()
                        : '',
                }
            );
    }

    componentDidUpdate(prevProps) {
        const { immCheckStatus, immStepsState, stepsActions } = this.props;
        const checkStatus = immCheckStatus.get('checkStatus');

        if (prevProps.immCheckStatus.get('checkStatus') !== checkStatus) {
            if (
                checkStatus === SUITABILITY_TEST_UNSIGNED ||
                checkStatus === SUITABILITY_TEST_REDO ||
                checkStatus === SUITABILITY_TEST_VALID
            ) {
                const currentIndex = immStepsState.get('currentIndex');

                stepsActions.enablePreviousSteps({
                    index: currentIndex,
                });
            } else if (
                prevProps.immCheckStatus.get('checkStatus') === 0 &&
                checkStatus === SUITABILITY_TEST_IN_PROGRESS
            ) {
                this.retakeTest();
            }

            if (
                prevProps.immCheckStatus.get('checkStatus') === SUITABILITY_TEST_UNSIGNED &&
                immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID
            ) {
                const element = document.getElementById('otpSucessScroll');
                if (element) {
                    scroll.transition(element);
                }
            }
        }
    }

    recordEvent = (eventDetail = '', eventAction = '', eventCategory = EVENT_CATEGORY_SUITABILITY_TEST) => {
        const { userProfile } = this.props;

        let pathForTag;

        switch (userProfile.investmentType) {
            case ROBO:
                pathForTag = PATH_ROBO_TI;
                break;
            case GBI:
                pathForTag = PATH_GBI_TI;
                break;
            case ROBO_REJECTED:
            case GBI_REJECTED:
                pathForTag = PATH_RA_REJECTED;
                break;
            default:
                pathForTag = '';
                break;
        }

        UtagHelper.recordEventRoboGBI(pathForTag, eventCategory, eventAction, eventDetail, userProfile);
    };

    startTest = () => {
        const { userProfile, immStepsState, formActions, stepsActions, immCheckStatus } = this.props;
        const checkStatus = immCheckStatus.get('checkStatus');
        if (!userProfile.testStarted) {
            const currentIndex = immStepsState.get('currentStep');

            formActions.change('userProfile.testStarted', true);
            Storage.cookies.set('RASuitabilityStarted', true);

            stepsActions.disablePreviousSteps({
                index: currentIndex,
            });
        }
        if (checkStatus === SUITABILITY_TEST_IN_PROGRESS) {
            const isRobo = userProfile.investmentType === ROBO;
            const pathForTag = isRobo ? PATH_ROBO_TI : PATH_GBI_TI;

            UtagHelper.recordEventRoboGBI(
                pathForTag,
                EVENT_CATEGORY_SUITABILITY_TEST,
                EVENT_ACTION_LOGIN_ROBO,
                EVENT_DETAIL_RETAKE_TEST,
                userProfile
            );
            this.retakeTest();
        }
    };

    retakeTest = () => {
        const { userProfile, raWizardActions, immSuitabilityTest } = this.props;
        const key = immSuitabilityTest.getIn(['lastAnswer', 'step', 'category']);
        const isExitTest = !immSuitabilityTest.get('lastAnswer');
        let index = immSuitabilityTest.getIn(['lastAnswer', 'step', 'step']);

        if (!userProfile.RASuitabilityTest) {
            index = -1;
        }
        raWizardActions.retakeTest({ key, index, isExitTest });
    };

    handleNewTestClick = () => {
        const { raWizardActions, formActions, suitabilityActions, stepsActions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');

        stepsActions.disablePreviousSteps({
            index: currentIndex,
        });

        suitabilityActions.resetAnswers();
        suitabilityActions.resetTestCompleted();
        formActions.change('userProfile.RASuitabilityTest', false);
        raWizardActions.getSteps();
        this.startTest();

        this.recordEvent(EVENT_DETAIL_RETAKE_TEST, TEST_PROCESS_STEP_FAILURE);
    };

    handleConfirm = () => {
        const { jointHoldersActions, userProfile } = this.props;
        this.setState({ showOtpComponent: true });
        jointHoldersActions.getNewOtp(userProfile.accessToken);
        this.recordEvent(EVENT_DETAIL_SIGN, TEST_PROCESS_STEP_SUCCESS);
    };

    handleOnClose = () => {
        this.props.modalCancelActions.showModalCancel();
    };

    sendOkSuitabilityTest() {
        const { userProfile, preLoaderActions, suitabilityActions, goToErrorsView } = this.props;
        suitabilityActions.sendOkSuitabilityTest(userProfile.accessToken, (verifiedOk, errors) => {
            preLoaderActions.hidePreLoader();
            if (verifiedOk) {
                this.goToNextStep();
            } else {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002, errorMessage: ERROR_TEST_IDONEIDAD });
                }
                this.setState({ isClicked: false });
            }
        });
    }

    sendRoboReject() {
        const { userProfile, preLoaderActions, suitabilityActions, goToErrorsView } = this.props;
        preLoaderActions.showPreLoader();
        suitabilityActions.sendRoboReject(userProfile.accessToken, (verifiedOk, errors) => {
            if (verifiedOk) {
                this.props.preLoaderActions.hidePreLoader();
                this.goToFiocStep();
            } else {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_EVIAR_RECHAZO_ROBO });
                }
                this.setState({ isClicked: false });
            }
        });
    }

    sendGbiReject = () => {
        const { userProfile, preLoaderActions, suitabilityActions, goToErrorsView } = this.props;
        preLoaderActions.showPreLoader();
        suitabilityActions.sendGbiReject(userProfile.accessToken, (verifiedOk, errors) => {
            if (verifiedOk) {
                preLoaderActions.hidePreLoader();
                this.goToFiocStep();
            } else {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: 6002, errorMessage: ERROR_AL_EVIAR_RECHAZO_GBI });
                }
                this.setState({ isClicked: false });
            }
        });
    };

    onContinueSuccess = () => {
        const { immCheckStatus, preLoaderActions, immStepsState } = this.props;

        const currentIndex = immStepsState.get('currentStep');
        const finished = immStepsState.getIn(['steps', currentIndex, 'finished']);

        if (immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID && !finished) {
            preLoaderActions.showPreLoader();
            this.sendOkSuitabilityTest();
        } else {
            this.goToNextStep();
        }
    };

    isTestCompleted() {
        const { immCheckStatus } = this.props;

        const suitabilityTestIsValid =
            immCheckStatus.get('checkStatusFetched') && immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID;

        return suitabilityTestIsValid;
    }

    goToFiocStep() {
        const { immStepsState, stepsActions } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.get('readOnlyForms');

        this.setState({ isClicked: false });

        if (!disabled) {
            stepsActions.enablePreviousSteps({
                index: currentIndex,
            });
            stepsActions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            stepsActions.finalizeStep({
                index: currentIndex + 1,
                finished: true,
            });
            stepsActions.enableFinishedAndNextStep();
            stepsActions.changeCurrentStep({
                index: currentIndex + 2,
            });
        } else {
            stepsActions.changeCurrentStep({
                index: currentIndex + 2,
            });
        }
    }

    goToNextStep = () => {
        const { immStepsState, stepsActions } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.get('readOnlyForms');

        this.setState({ isClicked: false });

        if (!disabled) {
            stepsActions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            stepsActions.enableFinishedAndNextStep();
            stepsActions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            stepsActions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    };

    handlePrevStep = () => {
        const { immStepsState, stepsActions } = this.props;
        const currentStep = immStepsState.get('currentStep');

        stepsActions.changeCurrentStep({
            index: currentStep - 1,
        });
    };

    buildSuccess() {
        const { immSuitabilityTest, immCheckStatus } = this.props;

        const immResults = immSuitabilityTest.getIn(['results', 0]);
        if (!immResults) {
            return <LoadingSection />;
        }

        const disclaimer = immResults.get('resultDescription', '');
        const firstParagraph = immResults.get('clientRiskProfileDescription', '');
        const profile = immResults.get('clientRiskProfileTitle', '');
        const secondParagraph = immResults.get('maxTypeOfProductDescription', '');
        const signedTest = immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID;
        const enabled =
            signedTest &&
            (!this.state.showOtpComponent || (this.state.showOtpComponent && immSuitabilityTest.get('isValidOTP')));
        const showOtp = this.state.showOtpComponent || signedTest;

        if (!getRecordedTestSuccess()) {
            this.recordEvent(EVENT_DETAIL_RESULT_LOAD, TEST_PROCESS_STEP_SUCCESS);
            recordedTestSuccess();
        }

        return (
            <div className="ra-test-data-view__success">
                <Headline icon="documentos" className="prospects-gutter">
                    <h2>
                        <FormattedText value="raSuitabilityTest-headlineTestSuccess" />
                    </h2>
                </Headline>
                <div className="persona-data-view">
                    <RASuitabilityTestSuccess
                        disclaimer={disclaimer}
                        firstParagraph={firstParagraph}
                        onConfirm={this.handleConfirm}
                        profile={profile}
                        secondParagraph={secondParagraph}
                        showOtpComponent={showOtp}
                    />
                </div>
                <div id="otpSucessScroll" className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueAction={() => {
                                this.onContinueSuccess();
                                this.recordEvent(EVENT_DETAIL_BUTTON_NEXT);
                            }}
                            buttonPrevAction={() => {
                                this.recordEvent(EVENT_DETAIL_BUTTON_PREV, TEST_PROCESS_STEP_SUCCESS);
                                this.handlePrevStep();
                            }}
                            buttonContinueDisabled={!enabled}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildFailure() {
        if (!getRecordedTestFailure()) {
            this.recordEvent(EVENT_DETAIL_RESULT_LOAD, TEST_PROCESS_STEP_FAILURE);
            recordedTestFailure();
        }

        return (
            <div className="prospects-step-content basic-layering">
                <Headline icon="documentos" className="prospects-gutter">
                    <h2>
                        <FormattedText value="raSuitabilityTest-headlineTestFailure" />
                    </h2>
                </Headline>
                <div className="persona-data-view">
                    <RASuitabilityTestFailure
                        exitTest={event => {
                            event.preventDefault();
                            this.recordEvent(EVENT_DETAIL_FINISH, TEST_PROCESS_STEP_FAILURE);
                            this.handleExitModal();
                        }}
                    />
                </div>
            </div>
        );
    }

    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    };

    closeModal = () => {
        this.recordEvent(EVENT_ACTION_EXIT_TEST, TEST_PROCESS_STEP_FAILURE);
        this.toggleModal();
    };

    exitTest = () => {
        const { formActions, userProfile } = this.props;
        Storage.cookies.remove('RASuitabilityStarted');
        if (userProfile.investmentType === ROBO) {
            formActions.change('userProfile.withoutRobo', true);
            this.sendRoboReject();
        } else if (userProfile.investmentType === GBI) {
            formActions.change('userProfile.withoutGbi', true);
            this.sendGbiReject();
        }
        this.toggleModal();
    };

    handleExitModal = () => {
        this.recordEvent(EVENT_DETAIL_MODAL_EXIT_OPEN, TEST_PROCESS_STEP_FAILURE);
        this.setState({
            showModal: true,
        });
    };

    buildLoginContent = () => {
        return (
            <Fragment>
                <div className="suitability-test__main-content">
                    <FormattedText value="raSuitabilityTest-mainContent" />
                </div>
                <LoginRoboContainer startTest={this.startTest} className="login-robo" />
            </Fragment>
        );
    };

    buildGBIContent = () => {
        const { immSetGoal } = this.props;
        const id = immSetGoal.getIn(['steps', 0, 'goalTypeSelected']);

        return (
            <Fragment>
                <div className="suitability-test-gbi">
                    <div className="suitability-test-gbi__image">
                        <RAImageButton iconType={id} id={id} isSelected size="small-test" />
                    </div>
                    <div className="suitability-test-gbi__main-content">
                        <p>
                            <FormattedText value="raSuitabilityTest-mainContent" />
                        </p>
                    </div>
                </div>
                <LoginRoboContainer startTest={this.startTest} className="login-robo-gbi" />
            </Fragment>
        );
    };

    buildPreTestContent = () => {
        const { userProfile } = this.props;
        const isGBI = userProfile.investmentType === 'gbi';
        const footerContentClass = classNames('footer-padding', { 'footer-padding--gbi': isGBI });
        const content = isGBI ? this.buildGBIContent() : this.buildLoginContent();

        return (
            <RASuitabilityTestWrapper
                content={content}
                footerContentClass={footerContentClass}
                buttonPrevAction={() => {
                    this.recordEvent(EVENT_DETAIL_BUTTON_PREV, EVENT_ACTION_PASSWORD_RECOVERY);
                    this.handlePrevStep();
                }}
                buttonCancelAction={() => {
                    this.recordEvent(EVENT_DETAIL_EXIT, EVENT_ACTION_PASSWORD_RECOVERY);
                    this.props.modalCancelActions.showModalCancel();
                }}
            />
        );
    };

    render() {
        const { immCheckStatus, immSuitabilityTest, userProfile, loginRobo } = this.props;
        const checkStatus = immCheckStatus.get('checkStatus');
        const isLogged = loginRobo.get('isLoggedIn');
        let content = <LoadingSection />;
        if (!userProfile.withoutRobo && !userProfile.withoutGbi) {
            if (
                !immSuitabilityTest.get('isSendingTest') &&
                !immSuitabilityTest.get('isFetchingQuestions') &&
                !immCheckStatus.get('isFetchingCheckStatus')
            ) {
                if (
                    immSuitabilityTest.get('testCompleted') &&
                    (checkStatus === SUITABILITY_TEST_UNSIGNED ||
                        checkStatus == SUITABILITY_TEST_REDO ||
                        checkStatus == SUITABILITY_TEST_VALID)
                ) {
                    content = immSuitabilityTest.get('success') ? this.buildSuccess() : this.buildFailure();
                } else if (!isLogged) {
                    content = this.buildPreTestContent();
                } else if (immSuitabilityTest.get('questions').size > 0 && checkStatus !== SUITABILITY_TEST_VALID) {
                    content = (
                        <div className="prospects-step-content basic-layering">
                            <Headline className="prospects-gutter text-center" withIcon={false}>
                                <h2>
                                    <FormattedText value="raSuitabilityTestWizard-headline" />
                                </h2>
                                <div className="close-test" onClick={this.handleOnClose}>
                                    <img src={Close} alt="" />
                                </div>
                            </Headline>
                            <RAWizard />
                            <RAWizardContent />
                        </div>
                    );
                } else if (checkStatus === SUITABILITY_TEST_VALID) {
                    content = this.buildSuccess();
                }
            }
        } else {
            const title = userProfile.withoutGbi
                ? formatText('raSuitabilityTest-gbiRejectedTitle')
                : formatText('raSuitabilityTest-roboRejectedTitle');
            const subtitle = userProfile.withoutGbi
                ? formatText('raSuitabilityTest-gbiRejectedSubtitle')
                : formatText('raSuitabilityTest-roboRejectedSubtitle');

            content = (
                <RARejected
                    title={title}
                    subtitle={subtitle}
                    onContinueAction={() => {
                        this.recordEvent(
                            EVENT_DETAIL_BUTTON_NEXT,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED
                        );
                        this.goToNextStep();
                    }}
                    onPrevAction={() => {
                        this.recordEvent(
                            EVENT_DETAIL_BUTTON_PREV,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED
                        );
                        this.handlePrevStep();
                    }}
                />
            );
        }

        return (
            <div className="ra-test-data-view">
                {content}
                <RAModal
                    title={<FormattedText value="raSuitabilityTest-exitModalTitle" />}
                    text={formatText('raSuitabilityTest-exitModalText')}
                    firstButton={formatText('raSuitabilityTest-exitModalButtonContinue')}
                    secondButton={formatText('raSuitabilityTest-exitModalButtonExit')}
                    firstAction={() => {
                        this.recordEvent(EVENT_DETAIL_MODAL_EXIT_NEXT, TEST_PROCESS_STEP_FAILURE);
                        this.exitTest();
                    }}
                    secondAction={this.closeModal}
                    show={this.state.showModal}
                    hide={() => {
                        this.recordEvent(EVENT_DETAIL_CLOSE_MODAL, TEST_PROCESS_STEP_FAILURE);
                        this.toggleModal();
                    }}
                    classButtons="exit-modal-buttons"
                />
            </div>
        );
    }
}

export const RASuitabilityTestView = connect(
    state => ({
        immCheckStatus: state.raCheckStatus,
        immSetGoal: state.raSetGoal,
        immStepsState: state.steps,
        userProfile: state.userProfile,
        immSuitabilityTest: state.raSuitabilityTest,
        loginRobo: state.loginRobo,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        suitabilityActions: bindActionCreators(suitabilityActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        raWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(RASuitabilityTestViewComponent);
